import moment from 'moment'
import { getSearchParams } from './utils'

export const ENTER_KEY = 13
export const DATE_LENGTH = 8
export const APP = process.env.REACT_APP_BASE_URL
export const APP_LOGIN = APP + '/api/user/login/'
export const APP_LOGOUT = APP + '/api/user/logout/'
export const APP_ALLOWACCESS = APP + '/api/user/eventhandler/?event=allowaccess'
export const APP_REGISTRATION = APP + '/api/user/sendmail_form02/'
export const APP_FEEDBACK = APP + '/api/user/sendmail/'
export const APP_FEEDBACK_PERSONAL = APP + '/api/user/sendmail_form03/'
export const APP_ANNOUNCE = APP + '/api/user/send_announce/'
export const APP_GET_USER = APP + '/api/user/get_preferences/'
export const APP_SET_USER = APP + '/api/user/set_preferences/'
export const APP_GRAPHQL = process.env.REACT_APP_GRAPHQL_URL

export const DOMAIN = window.location.origin
export const RECAPTCHA_SITE_KEY = '6LeGlD8aAAAAACUpDmnczCiYJ0auL7fnGHErRRLB'

export const AUTH_LOGIN = 'Login OK'
export const AUTH_LOGOUT = 'Logout OK'
export const AUTH_NOT_AUTHORIZED = 'not_authorized'
export const AUTH_ERROR = 'Login incorrect [2]'
export const AUTH_SESSION_IS_ACTIVE = 'Another session is active.'
export const AUTH_ERROR_MESSAGE = `Неверный логин и пароль. Есть вопросы? Напишите нам: <a href="mailto:podpiska@ria.ru">podpiska@ria.ru</a>`
export const AUTH_ERROR_MESSAGE_2 = `Неверный логин или пароль. Если вы не получали сообщения о смене данных, пожалуйста, свяжитесь с менеджером для уточнения <a href="mailto:podpiska@ria.ru">podpiska@ria.ru</a>`
export const AUTH_NO_ACTIVE_SUBSCRIPTION = 'There are no active subscriptions'
export const AUTH_NO_ACTIVE_SUBSCRIPTION_MESSAGE = `Закончился срок подписки. Для продления свяжитесь с нами <a href="mailto:podpiska@ria.ru">podpiska@ria.ru<a/>`

export const CATEGORY_RIAN = 16
export const CATEGORY_ONLINE = 53

export const USER_ACTION = {
	LOGIN: 'login',
	LOGOUT: 'logout',
	SET_CATEGORIES: 'setCategories',
	SET_PARAMS: 'setParams',
}

export const MODAL_ACTION = {
	OPEN: 'open',
	CLOSE: 'close',
	MODAL_TOGGLE: 'modalToggle',
	SET_PARAMS: 'setParams'
}

export const CATEGORIES_ACTION = {
	ADD_CATEGORIES: 'addCategories',
	SET_CATEGORIES: 'setCategories',
	RESET: 'reset',
}

export const FILTER_ACTION = {
	SET_FILTER: 'setFilter',
	RESET_FILTER: 'resetFilter',
}

export const EVENT_ACTION = {
	SET_EVENT: 'setEvent',
}

export const TOUR_ACTION = {
	OPEN: 'open',
	CLOSE: 'close',
	SET_INDEX: 'setIndex',
	OPEN_DROPDOWN: 'openDropdown'
}

export const INITIAL_FILTER = {
	get q() {return getSearchParams('q') || ''},
	get fd() {return getSearchParams('fd') || new Date()},
	get td() {return getSearchParams('fd') || null},
	limit: 15,
	priority: 0,
	list_ids_arr: [1]
}

export const RELEVANT_INITIAL_FILTER = {
	get q() {return getSearchParams('q') || ''},
	get fd() {return getSearchParams('fd') || new Date()},
	get td() {return getSearchParams('fd') || null},
	limit: 3,
	priority: 1,
	list_ids_arr: [1]
}

export const SEARCH_INITIAL_FILTER = {
	get q() {return getSearchParams('q') || ''},
	get fd() {return getSearchParams('fd') || new Date()},
	get td() {return getSearchParams('fd') || null},
	limit: 20,
	list_ids_arr:[]
}

export const INITIAL_HISTORY = {
	get fd() {return getSearchParams('fd') || new Date()},
	get td() {return getSearchParams('fd') || null},
	limit: 5,
	list_ids_arr: [72]
}

export const FORM = {
	LOGIN: 'login',
	PASSWORD: 'pwd',
	FIRST_NAME: 'first_name',
	LAST_NAME: 'last_name',
	EMAIL: 'email',
	COMPANY: 'company_name',
	PHONE: 'phone',
	POLICY: 'agreement_accepted',
	RECAPTCHA: 'g-recaptcha-response',
	MESSAGE: 'message',
	SUBJECT: 'subject',
	NAME: 'name',
	REFERER: 'referer'
}

export const ERRORS_FORM_REGISTRATION = {
	[FORM.FIRST_NAME]: 'Пожалуйста, введите свое имя',
	[FORM.LAST_NAME]: 'Пожалуйста, введите свою фамилию',
	[FORM.EMAIL]: 'Пожалуйста, введите свою почту',
	[FORM.COMPANY]: 'Пожалуйста, введите название организации',
	[FORM.PHONE]: 'Пожалуйста, введите свой телефон',
	[FORM.REFERER]: 'Пожалуйста, заполните поле «Откуда Вы узнали о нас?»',
	[FORM.POLICY]:'Пожалуйста, примите условия соглашения',
	[FORM.RECAPTCHA]: 'Ошибка reCaptcha',
}

export const ERRORS_FORM_FEEDBACK = {
	[FORM.FIRST_NAME]: 'Пожалуйста, введите свое имя',
	[FORM.LAST_NAME]: 'Пожалуйста, введите свою фамилию',
	[FORM.EMAIL]: 'Пожалуйста, введите свою почту',
	[FORM.MESSAGE]: 'Пожалуйста, введите ваше сообщение'
}

export const ERRORS_FORM_FEEDBACK_PERSONAL = {
	[FORM.NAME]: 'Пожалуйста, введите свое имя',
	[FORM.EMAIL]: 'Пожалуйста, введите свою почту',
	[FORM.SUBJECT]: 'Пожалуйста, введите тему сообщения',
	[FORM.MESSAGE]: 'Пожалуйста, введите ваше сообщение'
}

export const ERRORS_FORM_SEND_ANNOUNCE = {
	[FORM.EMAIL]: 'Пожалуйста, введите свою почту',
	[FORM.MESSAGE]: 'Пожалуйста, введите текст сопроводительного письма'
}